import { Outlet } from 'react-router';
import { AppBreadcrumbs } from '../components/AppBreadcrumbs';
import { Navigation } from '../components/Navigation';

export function AuthenticatedLayout() {
  return (
    <div className="min-h-screen bg-page-bg text-foreground font-sans transition-colors duration-200">
      <Navigation />
      <AppBreadcrumbs />
      <Outlet />
    </div>
  );
}